
/* eslint-disable */
import {
   defineComponent,
   PropType,
   onMounted,
   reactive,
   toRef,
   toRefs,
   ref,
   computed,
   watch,
   onActivated
} from "vue";
import { ElImageViewer } from "element-plus";
import $api from "@/api/main";
import utils from '@/utils/utils';
import Bus from "@/bus";
import { baseURL, privewURL } from "@/utils/request";
import { flowHooks } from "@/hooks/factoryHooks";

export default defineComponent({
   props: {
      /**
       *  当前流程id
       */
      processInstanceId: {
         type: String,
         default: '',
      },
   },
   setup(props, ctx) {
      const data: any = reactive({
            flowList: [],
            currentTask:[],
            imageList:[],
            showViewer: false,
            isCurrentUser: false
        });

      // 获取工作流程详情
      const getProcessTaskCirculationFn = async ()=>{
         let result = await $api.getProcessTaskCirculation(props.processInstanceId);
         if(result){
            result.forEach((item:any)=>{
               item.message = JSON.parse(item.message);
               if(item.message !== null){
                  let approveData:any = [];
                  let arr = Object.getOwnPropertyNames(item.message).filter((fItem)=>{ return fItem.indexOf('label') !== -1 });
                  arr.forEach((aItem:any)=>{
                     let json:any = {};
                     if(aItem.split('_').length === 3){
                        json.value = item.message[`${aItem.split('_')[0]}_${aItem.split('_')[1]}`] || '无'
                     }else{
                        if(aItem.split('_')[0] === 'finesConfirm' && item.message[`${aItem.split('_')[0]}`] === false){
                           json.value = '未缴纳';
                        }else if(aItem.split('_')[0] === 'finesConfirm' && item.message[`${aItem.split('_')[0]}`] === true){
                           json.value = '已缴纳';
                        }else{
                           json.value = item.message[`${aItem.split('_')[0]}`] || '无'
                           // if(aItem.indexOf('Amount') !== -1){
                           //    json.value = utils.$currency(item.message[`${aItem.split('_')[0]}`], { symbol: '¥' }).format();
                           // }else{
                           //    json.value = item.message[`${aItem.split('_')[0]}`] || '无'
                           // }
                        }
                     }
                     json.key = item.message[aItem];
                     json.key_p = aItem;

                     if((json.key.indexOf('金额') !== -1 && json.key.indexOf('进度款金额是否合理') === -1) || json.key.indexOf('累计已付款') !== -1){
                        json.value = utils.$currency(json.value, { symbol: '¥' }).format();
                     }

                     if(json.key_p === 'file_label' && json.value !== '无'){
                        json.value.forEach((item:any) => {
                           item.fileUrl = `${baseURL}public/file/${item.fileId}?token=${utils.$cookie.getCookie(
                              utils.$tokenStr
                           )}`
                        });
                     }
                     if(json){
                        approveData.push(json);
                     }
                  });
                  approveData.push({
                     key:'审核时间',
                     value: item.endTime,
                  });
                  let delIndex = approveData.findIndex((item: any)=>{ return item.key === '审核结果' });
                  let delItem = approveData[delIndex];
                  if(delItem){
                     approveData.splice(delIndex,1);
                     approveData.unshift(delItem);
                  }
                  item.aproveData = approveData;
               }
            });
         }
         data.flowList = result;
         let reverseResult = JSON.parse(JSON.stringify(result)).reverse();
         let reverseArr:any = [];
         reverseResult.forEach((item:any) => {
            if(item.message){
               for(let key in item.message){
                  if(key === 'agreePayAmount'){
                     reverseArr.push({key:'agreePayAmount',value:item.message[key]});
                     Bus.$emit("thorwAgreePayAmount",item.message[key]);
                  }
                  if(key === 'agreePaymentLabourAmount'){
                     reverseArr.push({key:'agreePaymentLabourAmount',value:item.message[key]});
                     Bus.$emit("thorwAgreePaymentLabourAmount",item.message[key]);
                  }
                  if(key === 'agreePaymentMaterialAmount'){
                     reverseArr.push({key:'agreePaymentMaterialAmount',value:item.message[key]});
                     Bus.$emit("thorwAgreePaymentMaterialAmount",item.message[key]);
                  }
               }
            }
         });
         if(reverseArr.length > 0){
            reverseArr.reverse().forEach((item:any)=>{
               switch (item.key) {
                  case 'agreePayAmount':
                     Bus.$emit("thorwAgreePayAmount",item.value);
                     break;
                  case 'agreePaymentLabourAmount':
                     Bus.$emit("thorwAgreePaymentLabourAmount",item.value);
                     break;
                  case 'agreePaymentMaterialAmount':
                     Bus.$emit("thorwAgreePaymentMaterialAmount",item.value);
                     break;
               }
            });
         }else{
            Bus.$emit("thorwAgreePayAmount",0);
            Bus.$emit("thorwAgreePaymentLabourAmount",0);
            Bus.$emit("thorwAgreePaymentMaterialAmount",0);
         }
      }

      // 获取下一个流程审批人
      const getCurrentTaskInfoFn = async ()=>{
         data.currentTask = [];
         data.isCurrentUser = false;
         let result = await $api.getCurrentTaskInfo(props.processInstanceId);
         if(result && result.length > 0){
         data.currentTask = result;
         data.isCurrentUser = utils.$cookie.getCookie('hxUserCode') === result[0].assignee;
         }
      }

      const previewFn = (val:any)=>{
         if (
            val.fileName.indexOf("png") === -1 &&
            val.fileName.indexOf("jpg") === -1 &&
            val.fileName.indexOf("jpeg") === -1
         ) {
            window.open(
               `${baseURL}public/file/${val.fileId}?token=${utils.$cookie.getCookie(
                  utils.$tokenStr
               )}`
            );
         } else {
            data.imageList.push(val.fileUrl);
            data.showViewer = true;
         }
      }

      /**
      * 监听processInstanceId变化
      */
      watch(()=>props.processInstanceId,(val)=>{
         if(val){
               getProcessTaskCirculationFn();
               getCurrentTaskInfoFn();
         }
      })
      

      onMounted(() => {
         if(props.processInstanceId){
            getProcessTaskCirculationFn();
         }
      });
      onActivated(() => {
         if(props.processInstanceId){
            getProcessTaskCirculationFn();
         }
      });

      return {
         data,
         previewFn
      };
   },
});
